import APIClient from '@/shared/http/clients/api'

const resourceName = 'PDRRelatorioFormularioItem'
const APIPci = process.env.APIBaseURLPci

const GetAllGoal = (data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/meta`, data, config)
const CreateGoal = (data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}/meta`, data, config)

const PDRItemFormReportRepository = {
  CreateGoal,
  GetAllGoal
}
export default PDRItemFormReportRepository



//////////////////
// WEBPACK FOOTER
// ./src/shared/http/repositories/pci/pdritemformreport
// module id = null
// module chunks = 